import IntegrationToken from '@apps/finance/admin/tokens/integration'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    bank: PropTypes.object,
    integration: PropTypes.string
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { bank } = this.props
    return {
      title: 't(Edit Bank Account)',
      method: 'PATCH',
      endpoint: `/api/admin/finance/banks/${bank.id}/edit`,
      action: `/api/admin/finance/banks/${bank.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true }
          ]
        },
        ...this._getIntegration()
      ]
    }
  }

  _getIntegration() {
    const { integration } = this.props
    if(!integration) return []
    return [{
      label: <IntegrationToken integration={ integration } />,
      padded: false,
      fields: [
        { label: 't(Bank Code)', name: 'integration.bank_code', type: 'textfield' }
      ]
    }]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(invoice) {
    this.context.modal.close()
  }

}

export default Edit
